import { createLocaleEnvironment } from './Locale'

export const DEFAULT_LOCALE = 'en-au'

export const { locales, LocaleContextProvider, useLocaleContext } =
  createLocaleEnvironment({
    locales: [DEFAULT_LOCALE],
  })
